import {
  BUSINESS_ALLOWED_ROLES,
  BUSINESS_ROLE_PERMISSIONS,
  normalizeAuthList,
} from "@/constants/businessAccess"

export const useBusinessAccess = () => {
  const authStore = useAuthStore()

  const roles = computed(() => normalizeAuthList(
    authStore.authStore?.role ?? useCookie("role").value,
  ))

  const permissions = computed(() => {
    const result = new Set()
    roles.value.forEach(role => {
      const rolePermissions = BUSINESS_ROLE_PERMISSIONS[role] || []
      rolePermissions.forEach(permission => result.add(permission))
    })
    return [...result]
  })

  const isBusinessUser = computed(() => roles.value.some(role => BUSINESS_ALLOWED_ROLES.includes(role)))
  const hasRole = required => !normalizeAuthList(required).length
    || normalizeAuthList(required).some(role => roles.value.includes(role))
  const can = required => !normalizeAuthList(required).length
    || normalizeAuthList(required).every(permission => permissions.value.includes(permission))

  return { roles, permissions, isBusinessUser, hasRole, can }
}
